import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxSidenavContainerComponent } from './nx-sidenav-container.component';
import {MatSidenavModule} from '@angular/material/sidenav';



@NgModule({
  declarations: [
    NxSidenavContainerComponent
  ],
  imports: [
    CommonModule,
    MatSidenavModule
  ],
  exports: [
    NxSidenavContainerComponent
  ]
})
export class NxSidenavContainerModule { }
